import { render, staticRenderFns } from "./StockTransAddDialog.vue?vue&type=template&id=5ae9227d&scoped=true"
import script from "./StockTransAddDialog.vue?vue&type=script&lang=js"
export * from "./StockTransAddDialog.vue?vue&type=script&lang=js"
import style0 from "./StockTransAddDialog.vue?vue&type=style&index=0&id=5ae9227d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae9227d",
  null
  
)

export default component.exports